<template>
    <div>
        <div class="mb-4 space-y-2">
            <h1 class="text-2xl font-semibold text-gray-700">Settings</h1>

            <UTabs v-model="selected" :items="navigationLinks" :ui="tabsUi">
                <template #default="{ item, selected }">
                    <div class="flex items-center space-x-2.5">
                        <UIcon :name="item.icon" class="w-4 h-4 flex-shrink-0" />
                        <span>{{ item.label }}</span>
                    </div>
                </template>
            </UTabs>
        </div>

        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
import { UserRole } from '~/types/user'

definePageMeta({ layout: 'default', middleware: 'auth', roles: [UserRole.admin, UserRole.medicalDirector] })

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

const selected = computed({
    get() {
        const index = navigationLinks.value.findIndex((item) => item.to === route.path)
        if (index === -1) {
            router.replace({ path: navigationLinks.value[0].to })
            return 0
        }

        return index
    },
    set(value) {
        router.replace({ path: navigationLinks.value[value].to })
    },
})

const navigationLinks = computed(() => {
    return [
        { label: 'Users', to: '/settings/users', icon: 'i-ph-users-duotone', hidden: !auth.hasRole(UserRole.admin) },
        { label: 'Providers', to: '/settings/providers', icon: 'i-ph-first-aid-kit-duotone', hidden: !auth.hasRole(UserRole.admin) },
        { label: 'Pricing', to: '/settings/products', icon: 'i-ph-currency-dollar-duotone', hidden: !auth.hasRole(UserRole.admin) },
        { label: 'Options', to: '/settings/options', icon: 'i-ph-rows-duotone' },
        { label: 'Field Posts', to: '/settings/field-posts', icon: 'i-ph-first-aid-duotone', hidden: !auth.isEnabled('field_posts') },
        { label: 'Verify', to: '/settings/verify', icon: 'i-ph-shield-check-duotone', hidden: !auth.hasRole(UserRole.admin) },
    ].filter((l) => !l.hidden)
})

const tabsUi = {
    wrapper: '-mx-4 sm:-mx-6 lg:-mx-8 space-y-0',
    container: 'border-b border-gray-300',
    list: {
        base: '!flex space-x-4 w-full overflow-x-auto sm:px-2 lg:px-4',
        background: 'bg-transparent',
        rounded: 'rounded-none',
        padding: 'p-0',
        height: 'h-auto',
        marker: {
            base: 'w-auto',
            wrapper: 'border-b-2 border-primary-600',
            background: 'bg-transparent',
            rounded: 'rounded-none',
            shadow: 'shadow-none',
        },
        tab: {
            base: 'h-auto w-auto',
            padding: 'px-4 py-2.5',
        },
    },
}
</script>
